export default {
  title: "Monitor de Correos"
  , form: {
    estatus: {
      options: {
        todos: { label: "Todos" }
        , pendiente: { label: "Pendiente" }
        , enviado: { label: "Enviado" }
        , error: { label: "Error" }
      }
      , label: "Estatus"
      , th: "Estatus"
    }
    , buscar: { label: "Buscar" }
    , id: { th: "ID" }
    , fechaalta: { th: "Fecha y hora de registro" }
    , fechaEnvio: { th: "Fecha y hora envío" }
    , de: { th: "Remitente" }
    , para: { th: "Destinatario" }
    , cc: { th: "CC (Con copia a)" }
    , cco: { th: "CCO (Con copia oculta)" }
    , asunto: { th: "Asunto" }
  }
  , errors: {
    BD4001: { text: "Ocurrió un error en el catálogo de Bitácora" }
    , WS4001: { text: "Ocurrió un error en el catálogo de Bitácora" }
    , JS4001: { text: "Ocurrió un error en el catálogo de Bitácora" }
    , CR4001: { text: "Ocurrió un error en el catálogo de Bitácora" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/bitacoras/monitorCorreos.js